<template>
  <div>
    <Header :lang="lang" @changeLang="changeLang"></Header>
    <Hero :lang="lang" ></Hero>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Hero from './components/Hero'

export default {
  name: 'App',
  props: ['lng'],
  components: {
    Header,
    Footer,
    Hero
  },
  data(){
    return{
      lang: "en-US"
    }
  },
  created(){
    let lang = this.lng ?? navigator.language
    switch(lang.substr(0,2)){
      case "en" : this.lang = "en-US";break;
      case "sv" : this.lang = "sv-SE";break;
      case "nb" : this.lang = "no-NO";break;
      case "no" : this.lang = "no-NO";break;
      default:
        this.lang = "en-US";
    }
    this.setIso(this.lang)
    document.title = this.__('title')
  },
  methods: {
    changeLang(lang){
      console.log("Language Changed", lang)
      this.lang = lang
      this.setIso(this.lang)
    }
  }

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
